import { Track } from '../../models/interfaces/track.interface';
import { courseMock } from './course.mock';

const tenantId = 'tenant-uuid';

export const trackMock: Track = {
  id: 'track-uuid',
  tenantId,
  name: 'Jeito de Fazer',
  coursesIds: [courseMock.id],
  description: 'Trilha com fundamentos de execucao e boas praticas.',
  coverImageUrl: 'https://picsum.photos/seed/track-1/640/360',
  courses: [courseMock],
  createdAt: new Date(),
  updatedAt: new Date(),
  isActive: true,
};

export const tracksMock: Track[] = [
  trackMock,
  {
    id: 'track-2',
    tenantId,
    name: 'Jeito de Inovar',
    coursesIds: ['course-2', 'course-3'],
    description: 'Trilha focada em inovacao e melhoria continua.',
    coverImageUrl: 'https://picsum.photos/seed/track-2/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-3',
    tenantId,
    name: 'Onboarding',
    coursesIds: ['course-4'],
    description: 'Trilha introdutoria para novos colaboradores.',
    coverImageUrl: 'https://picsum.photos/seed/track-3/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: 'track-4',
    tenantId,
    name: 'Jeito de Liderar',
    coursesIds: ['course-5', 'course-6'],
    description: 'Trilha para desenvolvimento de lideranca e gestao de times.',
    coverImageUrl: 'https://picsum.photos/seed/track-4/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-5',
    tenantId,
    name: 'Jeito de Ser',
    coursesIds: ['course-7'],
    description: 'Trilha para cultura organizacional e comportamento.',
    coverImageUrl: 'https://picsum.photos/seed/track-5/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-6',
    tenantId,
    name: 'Jeito de Zelar',
    coursesIds: ['course-8', 'course-9'],
    description: 'Trilha com foco em responsabilidade e excelencia operacional.',
    coverImageUrl: 'https://picsum.photos/seed/track-6/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: 'track-7',
    tenantId,
    name: 'Comunicacao Eficaz',
    coursesIds: ['course-10'],
    description: 'Trilha para aprimorar comunicacao interna e externa.',
    coverImageUrl: 'https://picsum.photos/seed/track-7/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-8',
    tenantId,
    name: 'Gestao de Projetos',
    coursesIds: ['course-11', 'course-12'],
    description: 'Trilha para planejamento, execucao e controle de projetos.',
    coverImageUrl: 'https://picsum.photos/seed/track-8/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-9',
    tenantId,
    name: 'Atendimento ao Cliente',
    coursesIds: ['course-13'],
    description: 'Trilha para fortalecer experiencia e sucesso do cliente.',
    coverImageUrl: 'https://picsum.photos/seed/track-9/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-10',
    tenantId,
    name: 'Produto e Inovacao',
    coursesIds: ['course-14', 'course-15'],
    description: 'Trilha para discovery, validacao e evolucao de produtos.',
    coverImageUrl: 'https://picsum.photos/seed/track-10/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-11',
    tenantId,
    name: 'Qualidade e Processos',
    coursesIds: ['course-16'],
    description: 'Trilha para padronizacao, melhoria continua e qualidade.',
    coverImageUrl: 'https://picsum.photos/seed/track-11/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: false,
  },
  {
    id: 'track-12',
    tenantId,
    name: 'Seguranca da Informacao',
    coursesIds: ['course-17', 'course-18'],
    description: 'Trilha para boas praticas de seguranca e privacidade de dados.',
    coverImageUrl: 'https://picsum.photos/seed/track-12/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'track-13',
    tenantId,
    name: 'Formacao de Especialistas',
    coursesIds: ['course-19', 'course-20'],
    description: 'Trilha para aprofundamento tecnico em areas estrategicas.',
    coverImageUrl: 'https://picsum.photos/seed/track-13/640/360',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
];
